module.exports = __webpack_public_path__ + "img/phone_bg_bar.3bddb80d.png";